export const GET_DYNAMIC_VARIABLES = 'GET_DYNAMIC_VARIABLES'
export const GET_DYNAMIC_VARIABLE_VALUES = 'GET_DYNAMIC_VARIABLE_VALUES'
